"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.getVisibleReports = getVisibleReports;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _preactCompat = require("preact-compat");

var _Report = _interopRequireDefault(require("./Report"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DEFAULT_VISIBLE_REPORT_COUNT = 3;

function isCollapsible(reportedContent) {
  return reportedContent.length > DEFAULT_VISIBLE_REPORT_COUNT;
}

function getVisibleReports(reportedContent, isCollapsed) {
  if (isCollapsible(reportedContent) && isCollapsed) {
    return reportedContent.slice(0, DEFAULT_VISIBLE_REPORT_COUNT);
  }

  return reportedContent;
}

var Reports = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(Reports, _PureComponent);

  var _super = _createSuper(Reports);

  function Reports() {
    var _this;

    (0, _classCallCheck2.default)(this, Reports);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      isCollapsed: true
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "toggleIsCollapsed", function () {
      _this.setState(function (_ref) {
        var isCollapsed = _ref.isCollapsed;
        return {
          isCollapsed: !isCollapsed
        };
      });
    });
    return _this;
  }

  (0, _createClass2.default)(Reports, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var reportedContent = this.props.reportedContent;
      var isCollapsed = this.state.isCollapsed;
      var filteredReports = getVisibleReports((0, _toConsumableArray2.default)(reportedContent), isCollapsed);
      return (0, _preact.h)("div", {
        className: "reported-content"
      }, (0, _preact.h)("div", {
        className: "reported-content__count"
      }, "Reports (", reportedContent.length, ")"), filteredReports.map(function (report) {
        return (0, _preact.h)(_Report.default, (0, _extends2.default)({}, report, {
          key: report.id
        }));
      }), isCollapsible(reportedContent) && (0, _preact.h)(_Button.default, {
        variant: "text",
        onClick: function onClick() {
          return _this2.toggleIsCollapsed();
        },
        endIcon: isCollapsed ? 'chevronDown' : 'chevronUp'
      }, isCollapsed ? 'Show all reports' : 'Collapse reports'));
    }
  }]);
  return Reports;
}(_preactCompat.PureComponent);

var _default = Reports;
exports.default = _default;